import React from 'react';
import { generateId, shortHandDate, translate } from '../../utility/functions';
import Table from '../../table/Table';
import Button from '../../forms/Button';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Radio from '../../forms/Radio';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';
import ImageIndex from '../../forms/formComponents/ImageIndex';
import ColorInput from '../../forms/formComponents/ColorInput';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const Deals = ({ ...props }) => {

    const [deals, refreshDeals] = GetState(QuestRoute.mobile.deals);
    // const [promoCodes, setPromo, updatePromoCodes] = GetState(QuestRoute.mobile.promoCodes);

    const DealForm = ({ values, ...props }) => (
        <>
            <Input
                label='Name'
                name='dealName'
                required
            />
            <Preput
                label='Details'
                name='description'
            />
            <Preput
                label='Terms'
                name='terms'
            />

            <Select
                label='Award Type'
                name='awardType'
                options={HSOptions.expressPass.awardType}
                required
            />

            {(values.awardType === 'DollarDiscItem' || values.awardType === 'ItemRate') && (
                <Radio
                    label='Item'
                    name='kioskItemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={e => {
                        e.label = e.name
                        e.value = e.id
                    }}
                    required
                />
            )}

            <Input
                label='Value'
                name='awardValue'
                type='price'
            />
            <Input
                label='Start Date'
                name='startDate'
                type='date'
            />
            <Input
                label='End Date'
                name='endDate'
                type='date'
            />
            <Input
                label='Claim Limit'
                name='claimLimit'
                type='number'
            />

            <Select
                label='Expiration Type'
                name='expirationType'
                options={HSOptions.expirationType}
                required
            />

            {
                values.expirationType === 'Custom' &&
                <Input
                    label='Expires in (Days)'
                    name='expires'
                    type='number'
                />
            }
            {
                values.expirationType === 'Date' &&
                <Input
                    label='Expires on'
                    name='expirationDate'
                    type='date'
                />
            }



            <ImageIndex />

            <ColorInput />

            <AutoSelectAndUpgrade />

            <LocationSelectors />

            <TerminalIDsSelector />
        </>
    )


    const deleteDeal = (deal) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${deal.dealName}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Wash Club',
                body: `Deleting ${deal.dealName}`,
                callback: () => HamQuest.delete(QuestRoute.mobile.editDeals(deal.dealId))
            },
            confirmed: {
                title: 'Success',
                body: `${deal.dealName} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshDeals()
        })
    }

    const editDeal = (deal) => {
        // console.log(deal)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${deal.dealName}`,
            body: (
                <Form
                    inputs={{ ...deal }}
                    onSubmit={e => HamQuest.put(QuestRoute.mobile.editDeals(e.dealId), { ...e })
                        .then(() => {
                            refreshDeals();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) => <DealForm values={values} />}
                </Form>
            )
        })
    }

    const addNewDeal = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Award`,
            body: (
                <Form
                    inputs={{
                        dealName: '',
                        details: '',
                        terms: '',
                        awardType: '',
                        awardValue: '',
                        startDate: '',
                        endDate: '',
                        claimLimit: '',
                        expirationType: '',
                        expires: '',
                        expirationDate: '',
                        kioskItemId: '',
                        allowUpgrades: '',
                        autoSelect: '',
                        logoColor: '',
                        logoImageIndex: '',
                        locations: [],
                        terminalIds: [],
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.mobile.deals, { ...e })
                        .then(() => {
                            refreshDeals();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add Deal'
                >
                    {({ values }) => <DealForm values={values} />}
                </Form>
            )
        })
    }

    return (
        <Table
            config={{
                label: 'Award Deals',
                controls: [<Button roles={userRoles.editProducts} onClick={addNewDeal}>Add New Deal</Button>],
                data: deals,
                headers: [
                    {
                        label: 'Award Name',
                        propKey: 'dealName',
                    }, {
                        label: 'Award Type',
                        propKey: 'awardType',
                        options: true,
                    }, {
                        label: 'Start Date',
                        propKey: 'startDate',
                    }, {
                        label: 'End Date',
                        propKey: 'endDate',
                    },
                ],
                renderFormat: (e) => (
                    <ManagementRow
                        key={generateId()}
                        controls={[
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editDeal(e)}>Edit</Button>,
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteDeal(e)}>Delete</Button>
                        ]}
                    >
                        <td>{e.dealName}</td>
                        <td>{translate(e.awardType)}</td>
                        <td>{shortHandDate(e.startDate)}</td>
                        <td>{shortHandDate(e.endDate)}</td>
                    </ManagementRow>
                )
            }}
        />
    );
}

export default Deals;